 const cardbody = document.querySelector('.card-body');
 const readReviews = (e) => {
   cardbody.classList.toggle("hidden");
 };

 document.querySelector(".read-reviews").addEventListener('click', readReviews);

 const bv_read_btn = document.querySelector('.bv_button_buttonFull');
 if (bv_read_btn) {
   bv_read_btn.addEventListener('click', readReviews);
 }
 
 setTimeout(function() {
   document.querySelector('.bv_main_container_row_flex')?.addEventListener('mouseenter', function(event) {
      const bv_button_buttonFullLength = document.getElementsByClassName('bv_button_buttonFull');
      if (bv_button_buttonFullLength.length > 0) {
        document.querySelector('.bv_button_buttonFull').addEventListener('click', function(event) {
        cardbody.classList.toggle("hidden");
         var bvContainer = document.querySelector('#BVRRSearchContainer');
          bvContainer.scrollIntoView();
        });
      }
   });
 },3000);

const singleVariants = document.querySelector(".product-form__input input");
const availableProductLength = document.getElementsByClassName('product-form__submit');
const pdpQuantity = document.querySelector('.product-form__quantity');
const mikMak = document.querySelector('.mikmak-discover');
const mikmakTrue = singleVariants.dataset.mikmak;
const biStock = singleVariants.dataset.bis;

const urlParams = new URLSearchParams(window.location.search);
const myParam = urlParams.get('variant');
const vId = "";
if (myParam) {
  const vId = myParam;
}
else {
  const vId = singleVariants.dataset.variantid;
}

if (myParam === '39480887771234') {
  document.querySelector('.offer-code-content').classList.remove('active');
  document.querySelector('.offer-code-content').classList.add('hidden');
}

const buybutton = document.querySelector('.buy-button');
const notifyPdps = document.querySelectorAll(".notify_form ");
if (availableProductLength.length > 0) {
  const availableProduct = document.querySelector('.product-form__submit');
  if (availableProduct.disabled) {  
   if (mikmakTrue == "false"){
      availableProduct.classList.remove('remove');
      pdpQuantity.classList.remove('remove');
     buybutton.classList.remove('hidden');
     mikMak.classList.add('remove');
     notifyPdps.forEach((notifyPdp) => {
        if (notifyPdp.dataset.notifyId === `variant_${vId}`) {
          notifyPdp.classList.add('hidden');
          notifyPdp.classList.add('hide');
        }
      });
   }
  else {
      notifyPdps.forEach((notifyPdp) => {
          notifyPdp.classList.add('hidden');
          notifyPdp.classList.add('hide');
      });
    availableProduct.classList.add('remove');
    pdpQuantity.classList.add('remove');
    buybutton.classList.add('hidden');
  }
} else {
  mikMak.classList.add('remove');
}
}


const productSwitcher = (e) => {
  const mikMak = document.querySelector('.mikmak-discover');
  const mik = e.target.dataset.mikmak;
  const bis = e.target.dataset.bis;
  const variantId = e.target.dataset.variantid;
  const barcode = e.target.dataset.upc;
  const quantity = document.querySelector('.product-form__quantity');
  const addCart = document.querySelector('.product-form__submit');
  const buybutton = document.querySelector('.buy-button');
  const mikmak = document.querySelector('.mikmak-discover');
  mikmak.dataset.mikmakUpcs = barcode;
  
  //const ordergroove = document.querySelector('#shopify-block-ordergroove_offer');
  const ogPrice = document.querySelector('.og-ss-price');
  const regularPrice = document.querySelector('.price-item--regular');
  const notifyForms = document.querySelectorAll(".notify_form ");
  
const offerCodetextLength = document.getElementsByClassName("offer-code-content")
  if (bannercustomctaLength?.length > 0) {
    const offerCodetext = document.querySelector('.offer-code-content').dataset;
    if (offerCodetext.variantid === variantId) {
      document.querySelector('.offer-code-content').classList.add('active');
      document.querySelector('.offer-code-content').classList.remove('hidden');
    }
    else {
      document.querySelector('.offer-code-content').classList.remove('active');
      document.querySelector('.offer-code-content').classList.add('hidden');
    }
  }
   
  
   if (e.target.classList.contains('disabled')) {
    if (mik == "false"){
      mikMak.classList.add('remove');
      quantity.classList.remove('remove');
      addCart.classList.remove('remove');
       buybutton.classList.remove('hidden');
      notifyForms.forEach((notifyForm) => {
        if (notifyForm.dataset.notifyId === `variant_${variantId}` && bis == "true") {
          document.querySelector(".notify_me_form").classList.remove('hidden');
          notifyForm.classList.remove('hidden');
          notifyForm.classList.add('active');          
        }else {          
          notifyForm.classList.remove('active');
          notifyForm.classList.add('hidden');
        }
      });
      
    } else {
      mikMak.classList.remove('remove');
      quantity.classList.add('remove');
      buybutton.classList.add('hidden');
      addCart.classList.add('remove');
      //ordergroove.classList.add('hidden');
      regularPrice.classList.remove('strike');
      ogPrice.classList.add('hidden');
       notifyForms.forEach((notifyForm) => {
         notifyForm.classList.add('hidden');
        if (notifyForm.dataset.notifyId === `variant_${variantId}`) {          
          notifyForm.classList.add('hidden');          
        }
      });
    }
   } else {
      mikMak.classList.add('remove');
      quantity.classList.remove('remove');
      buybutton.classList.remove('hidden');
      notifyForms.forEach((notifyForm) => {
        if (notifyForm.dataset.notifyId === `variant_${variantId}`) {
          document.querySelector(".notify_me_form").classList.add('hidden');
          notifyForm.classList.add('hidden');
          notifyForm.classList.remove('active');          
        }else {          
          notifyForm.classList.add('active');
          notifyForm.classList.remove('hidden');
        }
      });
     //ordergroove.classList.remove('hidden');
      setTimeout(function () {
        console.log('timeout');
        addCart.classList.remove('remove');
      }, 200);
     if (ogPrice.innerHTML.length > 0) {
       const subscriptionlength = document.getElementsByClassName("subscription-true");
        if (subscriptionlength.length > 0) {
         setTimeout(function () {
            const subscriptionclick = document.querySelector('.subscription-true');
           regularPrice.classList.add('strike');
          ogPrice.classList.remove('hidden');
           subscriptionclick.click();
          }, 1000);
        }
     }
    }
};

const productVariants = document.querySelectorAll(".product-form__input input");
productVariants.forEach((productVariant) => {
  productVariant.addEventListener('click', productSwitcher);
});

const customCart = (e) => { 
  const variantId3pack = e.target.parentNode.closest('.form');
   
  if(variantId3pack.elements['id'].value === '40428969295970') {    
    e.preventDefault();
    let formData = {
     'items': [
       {
        'id': 39480887771234,
        'quantity': 1
        },
         {
          'id': 40428969295970,
          'quantity': 1
        }
     ]
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      window.location.href = '/checkout';
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}
const offercartLength = document.getElementsByClassName('offer-cart');
if (offercartLength.length > 0) {
  document.querySelector(".product-form__buttons.offer-cart").addEventListener('click', customCart);
}
